export default {
  // 步骤导航
  steps_company_info: '公司信息',
  steps_company_document: '公司文件',
  steps_signatory_info: '签字人信息',
  steps_shareholder_info: '股东/实际受益人信息',
  steps_account_info: '账户信息',
  // 通用
  title: 'KYC认证',
  yes: '是',
  no: '否',
  save_as_draft: '保存草稿',
  upload_document: '上传文件',
  upload_tip: '请确保上传的数据图像文本清晰可见。',
  upload_format: '(最大10MB，格式 JPG、JPEG、PNG 或 PDF)',
  upload_format_short: '最大10MB，JPG/JPEG/PNG/PDF',
  to: '至',
  // 第一步：公司信息
  company_info_subtitle: '选择您的业务类型',
  company_info_business_type_corporation: '公司',
  company_info_business_type_sole_proprietorship: '独资企业',
  company_info_company_type: '公司类型',
  company_info_legal_name_en: '公司名称',
  company_info_registration_number: '公司注册编号',
  company_info_date_of_incorporation: '注册日期',
  company_info_date_of_expiry: '公司营业期限',
  company_info_tax_id: '税务识别号',
  company_info_registration_address: '公司经营地址',
  company_info_same_business_address: '实际营业地址是否与公司注册地址相同？',
  company_info_brand_name: '品牌名称 / 商品名称',
  company_info_business_website: '公司网站',
  company_info_business_scope: '经营范围',
  company_info_mcc: '商户类别码（MCC）',
  company_info_monthly_transaction: '每月交易额',
  company_info_type_of_business: '业务类型',
  company_info_exchange_name: '交易所名称',
  company_info_stock_code: '股票代码',
  company_info_settlement_currency: '结算货币（美元或当地货币）',
  company_info_settlement_account_location: '结算账户位置',
  company_info_settlement_account_name: '结算账户名称',
  company_info_settlement_account_number: '结算账户号码',
  company_info_swift_code: 'Swift代码（美元结算必填）',
  company_info_settlement_account_address: '结算账户地址',
  company_info_settlement_account_proof: '结算账户证明',
  company_info_placeholder_enter_legal_name: '输入公司名称',
  company_info_placeholder_enter_registration_number: '输入公司注册编号',
  company_info_placeholder_enter_tax_id: '输入税务识别号',
  company_info_placeholder_enter_registration_address: '输入公司经营地址',
  company_info_placeholder_enter_brand_name: '输入品牌名称 / 商品名称',
  placeholder_enter_website: '输入公司网站',
  placeholder_enter_business_scope: '输入经营范围',
  placeholder_enter_mcc: '输入商户类别码（MCC）',
  placeholder_enter_amount: '输入每月交易额',
  placeholder_enter_business_type: '输入业务类型',
  placeholder_enter_exchange_name: '输入交易所名称',
  placeholder_enter_stock_code: '输入股票代码',
  company_info_placeholder_enter_swift_code: '输入Swift代码',
  company_info_placeholder_search: '搜索',
  company_info_placeholder_enter_address_to_search: '输入地址搜索',
  company_info_placeholder_enter_name_to_search: '输入名称搜索',
  company_info_placeholder_enter_account_address_to_search: '输入账户地址搜索',
  company_info_company_type_option_limited: '有限公司',
  company_info_company_type_option_partnership: '合伙企业',
  company_info_company_type_option_sole: '独资企业',
  company_info_currency_option_usd: '美元',
  company_info_currency_option_thb: '泰铢',
  company_info_currency_option_sgd: '新加坡元',
  company_info_currency_option_other: '其他',
  // 额外通用字段（占位 + 验证文案）
  phone_number: '联系人电话',
  email: '联系人邮箱',
  full_name: '联系人姓名',
  store_photo: '办公室照片',
  placeholder_enter_phone: '输入联系人电话',
  placeholder_enter_email: '输入邮箱地址',
  placeholder_enter_name: '输入姓名',
  placeholder_date: 'YYYY-MM-DD',
  validation_phone_required: '请输入电话号码',
  validation_phone_invalid: '请输入正确的手机号码，以 08 开头',
  validation_email_required: '请输入邮箱地址',
  validation_email_invalid: '请输入正确的邮箱地址',
  validation_full_name_required: '请输入联系人姓名',
  validation_upload_company_registration: '请上传公司注册证书',
  validation_upload_articles: '请上传公司章程',
  validation_upload_tax_documents: '请上传税务文件',
  validation_upload_business_permit: '请上传营业许可证',
  // 第二步：公司文件
  company_document_articles_of_association: '公司章程',
  company_document_registration_certificate: '公司注册文件',
  company_document_tax_documents: '税务文件',
  company_document_business_permit: '营业许可证',
  company_document_license_permit: '牌照',
  company_document_annual_report: '年审文件',
  company_document_other_documents: '其他文件',
  // 第三步：签署人信息
  signatory_info_subtitle: '选择身份证类型',
  signatory_info_id_type_etc: '其他',
  signatory_info_id_type_passport: '护照',
  signatory_info_nationality: '国籍',
  signatory_info_id_type: '证件类型',
  signatory_info_legal_name_en: '法定名称',
  signatory_info_first_name: '名',
  signatory_info_middle_name: '中间名',
  signatory_info_last_name: '姓',
  signatory_info_position: '签字人职位',
  signatory_info_date_of_birth: '出生日期',
  signatory_info_residential_address: '居住地址',
  signatory_info_id_photo: '身份证照片',
  signatory_info_taxpayer_identity: '纳税人身份',
  signatory_info_authorization_letter: '签字授权书',
  signatory_info_id_number: '证件号码',
  signatory_info_id_photo_front: '证件照(正面)',
  signatory_info_id_photo_back: '证件照(反面)',
  placeholder_enter_id_number: '输入证件号码',
  validation_id_number_required: '请输入证件号码',
  validation_id_number_format: '证件号码只能包含字母和数字',
  validation_document_type_required: '请选择证件类型',
  validation_nationality_required: '请选择国籍',
  signatory_info_add_email: '添加邮箱/添加另一个邮箱',
  signatory_info_placeholder_enter_residential_address: '输入居住地址',
  signatory_info_placeholder_enter_email: '输入邮箱',
  signatory_info_nationality_option_th: '泰国',
  signatory_info_nationality_option_sg: '新加坡',
  signatory_info_nationality_option_other: '其他',
  signatory_info_position_option_director: '董事',
  signatory_info_position_option_auth_signatory: '授权签署人',
  signatory_info_position_option_other: '其他',
  // 第四步：股东信息
  shareholder_info_subtitle: '选择身份证类型',
  shareholder_info_id_type_etc: '其他',
  shareholder_info_id_type_passport: '护照',
  shareholder_info_id_photo: '身份证照片',
  shareholder_info_id_photo_front: '身份证照片（正面）',
  shareholder_info_id_photo_back: '身份证照片（背面）',
  shareholder_info_shareholding_ratio: '持股比例',
  shareholder_info_add_shareholder: '添加股东/添加另一个股东',
  shareholder_info_placeholder_enter_shareholding_ratio: '输入持股比例',
  // 第五步：账户信息
  account_info_subtitle: '选择身份证类型',
  account_info_id_type_etc: '其他',
  account_info_id_type_passport: '护照',
  account_info_settlement_currency: '结算货币（美元或当地货币）',
  account_info_settlement_account_location: '结算账户位置',
  account_info_settlement_account_name: '结算账户名称',
  account_info_settlement_account_number: '结算账户号码',
  account_info_swift_code: 'Swift代码（美元结算必填）',
  account_info_settlement_account_address: '结算账户地址',
  account_info_settlement_account_proof: '结算账户证明',
  account_info_placeholder_enter_address_to_search: '输入地址搜索',
  account_info_placeholder_enter_name_to_search: '输入名称搜索',
  account_info_placeholder_enter_settlement_account_number: '输入结算账户号码',
  account_info_placeholder_enter_swift_code: '输入Swift代码',
  account_info_placeholder_enter_account_address_to_search: '输入账户地址搜索',
  account_info_currency_option_usd: '美元',
  account_info_currency_option_thb: '泰铢',
  account_info_currency_option_sgd: '新加坡元',
  account_info_currency_option_other: '其他',
  // 账户页 - 银行相关
  account_info_bank_name: '银行名称',
  account_info_account_name: '账户名称',
  account_info_account_number: '账户号',
  account_info_account_proof: '账户证明文件',
  account_info_placeholder_bank_name: '输入银行名称',
  account_info_placeholder_account_name: '输入账户名称',
  account_info_placeholder_account_number: '输入账户号',
  save_draft_success: '草稿已保存',
  saving: '保存中...',
  save_failed: '保存失败',
  upload_debounce_warning: '上传操作过于频繁，请稍候再试',
  upload_required: '请上传{field}',
  next_step: '下一步',
  submit_application: '提交申请',
  submit_success: '提交成功',
  // 退出提示对话框
  exit_dialog_title: '完成账户实名',
  exit_with_unsaved: '您即将离开此页面，当前页面存在未保存的数据。是否要保存？',
  first_step_required: '请先完成第一步的基本信息填写',
  cancel: '取消',
  save: '保存',
  // 待处理弹窗
  pending_popup_title: '紧急待处理弹窗',
  pending_popup_tip: '您尚未提交实名资料，请前往实名认证。 (请提前准备好资料)',
  pending_rejected_tip: '当前账户存在未处理的待办事项，为了不影响您的正常使用，建议立即处理',
  pending_rejected_message: '您的认证信息被驳回，请修改后重新提交。',
  pending_business_type: '业务类型',
  pending_todo: '待办事项',
  pending_operation: '操作',
  pending_business_account_verification: '账户验证',
  pending_todo_intro: '您尚未提交实名信息，请前往完成实名认证。（请提前准备相关材料）',
  pending_item_1: '公司基本信息(联系方式；经营情况；交易信息等)',
  pending_item_2: '公司注册证书、公司章程、税务文件、经营许可/牌照等',
  pending_item_3: '公司注册人信息(证件照；证件号码等)',
  pending_item_4: '银行账户信息',
  pending_setup_now: '立即设置',
  // Verify Now 弹窗
  verify_popup_title: '完成账户实名',
  verify_main: '请先完成账户实名验证',
  verify_sub: '为确保您能正常使用 PayCools 服务，请先完成账户验证',
  verify_now: '立即验证',
  verifying_title: '实名认证审核中',
  verifying_main: '实名认证审核中',
  verifying_sub: '您的信息正在审核中，审核完成后即可使用该功能，请耐心等待',
  confirm: '确认',
  rejection_title: '请遵守以下要求：',
  // validation messages
  validation_company_name_required: '请输入公司名称',
  validation_company_registration_required: '请输入公司注册编号',
  validation_date_of_incorporation_required: '请输入注册日期',
  validation_tax_id_required: '请输入税务识别号',
  validation_registration_address_required: '请输入公司经营地址',
  validation_brand_name_required: '请输入品牌/商用名',
  validation_business_website_required: '请输入公司网站',
  validation_business_website_format: '请输入以 http:// 或 https:// 开头的网址',
  validation_business_scope_required: '请输入经营范围',
  validation_store_photo_required: '请上传办公场所照片',
  validation_mcc_required: '请输入商户类别码',
  validation_monthly_transaction_required: '请输入每月交易额',
  validation_company_type_required: '请选择公司类型',
  validation_business_address_required: '请输入公司经营地址',
  validation_type_of_business_required: '请输入业务类型',
  validation_exchange_name_required: '请输入交易所名称',
  validation_stock_code_required: '请输入股票代码',
  validation_bank_name_required: '请输入银行名称',
  validation_account_name_required: '请输入账户名称',
  validation_account_number_required: '请输入账户号码',
  validation_account_proof_required: '请上传账户证明文件',
  validation_idfront_required: '请上传证件正面照片',
  validation_idback_required: '请上传证件背面照片',
  validation_authorization_letter_required: '请上传授权书',
  validation_position_required: '请输入签字人职位',
  validation_all_fields_required: '请填写所有必填字段',
  validation_length_20_30: '长度必须在20到30个字符之间',
  validation_length_100: '长度必须在1到100个字符之间',
  validation_length_500: '长度必须在1到500个字符之间',
  // Dashboard KYC 提示横幅
  dashboard_kyc_title: '账号认证',
  dashboard_kyc_subtitle: '完成实名认证，为您的业务解锁无限可能',
  dashboard_kyc_btn_text: '去认证',
  // 删除确认
  confirm_remove_file: '确定要删除 {name} 吗？',
  // 文件数量限制提示
  validation_file_limit_exceeded: '当前限制为 {limit}，请删除后重新上传！'
}
